<template>
  <div v-if="device !== 'XS'" class="footerContainer">
    <div class="content">
      <div class="content-item">Aktualisiert {{timestamp}}</div>
      <div
        class="content-item cursor-pointer colorBlue"
        @click="openExtendedSidebar('Partneransicht')"
      >Partnerportale</div>
      <div
        class="content-item cursor-pointer colorBlue"
        @click="openExtendedSidebar('FAQ')"
      >FAQ</div>
      <div class="content-item cursor-pointer colorBlue" @click="openExtendedSidebar('Impressum')">Impressum</div>
      <div
        class="content-item cursor-pointer colorBlue"
        @click="openExtendedSidebar('Datenschutz')"
      >Datenschutz</div>
      <div class="content-item cursor-pointer">
        <a class="colorBlue" rel="noopener noreferrer" target="_blank" href="https://mobil.hessen.de/service/kontakt">Kontakt »</a>
      </div>
      <div class="content-item cursor-pointer colorBlue">
        <a class="colorBlue" rel="noopener noreferrer" target="_blank" href="https://mobil.hessen.de/">Hessen Mobil »</a>
      </div>
    </div>
    <div class="notification cursor-pointer">
      <SVGIcon name="notifcation_off" @click.native="newstickerOpen = !newstickerOpen"/>
      <!-- Anzahl MELDUNGEN unten rechts -->
      <div
        v-if="newstickerMeldungen.length !== 0"
        class="notification-count colorWhite backgroundRed borderRadius10 fontweight600 textcenter"
      >{{newstickerMeldungen.length}}</div>
      <Newsticker v-if="newstickerOpen" @close="newstickerOpen=false"/>
    </div>
  </div>
</template>

<script>
import Newsticker from './Newsticker.vue'

export default {
  name: 'Footer',
  components: {
    Newsticker
  },
  data: function () {
    return {
      newstickerOpen: false
    }
  },
  computed: {
    newstickerMeldungen () {
      return this.$store.state.newstickerMeldungen
    },
    device () {
      return this.$store.state.device
    },
    extendedSidebarActive () {
      return this.$store.state.ExtendedSidebarActive
    },
    ExtendedSidebarActiveLayer () {
      return this.$store.state.ExtendedSidebarActiveLayer
    },
    layerData () {
      const data = this.$store.state.layers.map(layer => layer.icons.data)
      return data
    },
    timestamp () {
      // layerdata um update von Map zu triggern
      const layerData = this.layerData
      const date = new Date()
      let hour = date.getHours()
      let min = date.getMinutes()
      hour = (hour < 10 ? '0' : '') + hour
      min = (min < 10 ? '0' : '') + min
      return hour + ':' + min + ' Uhr'
    }
  },
  methods: {
    openExtendedSidebar (optionName) {
      if (this.extendedSidebarActive) {
        if (this.ExtendedSidebarActiveLayer === optionName) {
          this.$store.commit('setExtendedSidebarActiveFalse')
        }
      } else {
        this.$store.commit('setExtendedSidebarActive')
      }
      this.$store.commit('setExtendedSidebar', optionName)
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}

.footerContainer {
  height: 50px;
  width: 100%;
  color: #8f979b;
  font-size: 13px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.content {
  display: flex;
  justify-content: start;
  width: calc(100% - 80px);
  margin-left: 30px;
}

.content-item {
  padding: 0 10px;
}

.notification {
  position: relative;
  margin-top: -10px;
}
.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  padding: 2.5px;
  height: 20px;
  width: 20px;
  line-height: 1.4;
}
</style>
